// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CitySectionSkeleton-categorySkeletonContainer-jOFoa {
    padding: 90px 0;
}

.CitySectionSkeleton-categorySkeletonHeading-bnu2T {
    max-width: 359px;
    height: 50px;
    border-radius: var(--radius-5);
    margin: 0 auto;
}

.CitySectionSkeleton-categorySkeletonLinkContainer-y3FLd {
    margin-top: 30px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.CitySectionSkeleton-categorySkeletonLink-MqAI9 {
    max-width: 60px;
    height: 26px;
    border-radius: var(--radius-5);
}

@media (max-width: 767px) {
    .CitySectionSkeleton-categorySkeletonContainer-jOFoa {
        padding: 48px 0;
    }

    .CitySectionSkeleton-categorySkeletonHeading-bnu2T {
        height: 34px;
        margin-bottom: 30px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Home/CitySectionSkeleton/CitySectionSkeleton.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;AAEJ","sourcesContent":[".categorySkeletonContainer {\n    padding: 90px 0;\n}\n\n.categorySkeletonHeading {\n    max-width: 359px;\n    height: 50px;\n    border-radius: var(--radius-5);\n    margin: 0 auto;\n}\n\n.categorySkeletonLinkContainer {\n    margin-top: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.categorySkeletonLink {\n    max-width: 60px;\n    height: 26px;\n    border-radius: var(--radius-5);\n}\n\n@media (max-width: 767px) {\n    .categorySkeletonContainer {\n        padding: 48px 0;\n    }\n\n    .categorySkeletonHeading {\n        height: 34px;\n        margin-bottom: 30px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categorySkeletonContainer": `CitySectionSkeleton-categorySkeletonContainer-jOFoa`,
	"categorySkeletonHeading": `CitySectionSkeleton-categorySkeletonHeading-bnu2T`,
	"categorySkeletonLinkContainer": `CitySectionSkeleton-categorySkeletonLinkContainer-y3FLd`,
	"categorySkeletonLink": `CitySectionSkeleton-categorySkeletonLink-MqAI9`
};
module.exports = ___CSS_LOADER_EXPORT___;
